module.exports = __webpack_public_path__ + "be95b02bd6a5771bd8d2961c7dc38b6c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/cube_red.png
 ** module id = 1051
 ** module chunks = 0
 **/